import React from 'react';
export function Header() {
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-93">
      <div className="max-w-7xl mx-auto px-6 py-6" data-id="element-94">
        <div className="flex items-center justify-center" data-id="element-95">
          <a href="https://www.appliedwisdomfornonprofits.org" className="flex items-center" data-id="element-96">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2nS7DFLwWAqzEiZwYgpb2c/awnplogo.png" alt="Applied Wisdom for the Nonprofit Sector" className="h-16" data-id="element-97" />
          </a>
        </div>
      </div>
    </header>;
}